<template>
    <div class="agreement-wrapper">
        <Information name="agreement"/>
    </div>
</template>

<script>

import Information from '@/components/Information.vue'

export default {
    name: 'Agreement',
    components: {
        Information
    }
}
</script>
